import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const Home = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Check for token in URL query parameters
    const params = new URLSearchParams(window.location.search);
    const tokenFromUrl = params.get("token");
    console.log('Token from URL params:', tokenFromUrl);
    if (tokenFromUrl) {
      // Store token in localStorage
      localStorage.setItem('token', tokenFromUrl);

      // Set token in request headers for future API calls
      if (window.fetch) {
        const originalFetch = window.fetch;
        window.fetch = function(url, options = {}) {
          options.headers = {
            ...options.headers,
            'Authorization': `Bearer ${tokenFromUrl}`
          };
          return originalFetch(url, options);
        };
      }
      // Set url without query params
      window.history.replaceState({}, document.title, window.location.pathname);
      
      
      // Redirect to landing page
      navigate('/landing');
      return;
    }
    const loadComponent = async (path, elementId) => {
      try {
        const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api${path}?style=true`);
        if (!response.ok) {
          throw new Error(`HTTP error: ${response.status}`);
        }
        const data = await response.text();
        const contentElement = document.getElementById(elementId);
        contentElement.innerHTML = data;

        // Find and run the scripts in the loaded HTML
        const scripts = contentElement.getElementsByTagName('script');
        for (let script of scripts) {
          const newScript = document.createElement('script');
          newScript.textContent = script.textContent;
          document.body.appendChild(newScript);
        }
      } catch (error) {
        console.error('Error loading page:', error);
      }
    };

    loadComponent('/login', 'loginContent');
    loadComponent('/signup', 'signupContent');

    const handleLoginSuccess = (event) => {
      console.log('Login successful, navigating to landing page', event.detail);
      navigate('/landing');
    };

    window.addEventListener('rbacLogin', handleLoginSuccess);

    return () => {
      window.removeEventListener('rbacLogin', handleLoginSuccess);
    };
  }, [navigate]);

  const spacerStyle = {
    height: '20px', // Adjust the height as needed
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center' }}>
      <div style={{ height: '20px' }}></div>
      <h1>RBAC Client Home Page - SAMPLE</h1>
      <div style={{ height: '20px' }}></div>
      <div id="loginContent"></div>
      <div style={{ height: '20px' }}></div>
      <div id="signupContent"></div>
    </div>
  );
};

export default Home;
